/* @flow weak */
import Container from 'components/Container.jsx';
import Progress from 'components/Progress.jsx';
import React from 'react';

const TeacherAddUploadTabUploading = ({ uploadPercentage }) => (
  <div className="TeacherAddUploadTab-loading">
    <Container size="xxsmall">
      <Progress label="Uploading…" percent={uploadPercentage} />
    </Container>
  </div>
);

TeacherAddUploadTabUploading.propTypes = {
  uploadPercentage: React.PropTypes.number.isRequired,
};

export default TeacherAddUploadTabUploading;



// WEBPACK FOOTER //
// ./src/groups/components/TeacherAddUploadTabUploading.jsx